export default function mapValues(items: any[], iterator) {
  const object = Object(items);
  const result = {};

  Object.keys(object).forEach((key) => {
    result[key] = iterator(object[key], key, object);
  });

  return result;
}
